var notMenuArr=[
  '/login',
]

var notSideBarArr = [
  '/customer_manage/customer_power',
  '/device_manage/device_cache',

]

export {
  notMenuArr,
  notSideBarArr
}



// WEBPACK FOOTER //
// ./src/common/js/notMenuArr.js